import React from 'react'
import Spinner from '../loading/Spinner.gif'
export const Loading = () => {

    return(
        <>
        
        </>
    )
}